/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Nav_LotsInputs */

const vi_scl_nav_lots = /** @type {(inputs: Scl_Nav_LotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách lô`)
};

/**

* @param {Scl_Nav_LotsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_nav_lots = /** @type {((inputs?: Scl_Nav_LotsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Nav_LotsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_nav_lots(inputs)
});